// Generated on 2025-11-07T20:51:49.791Z
// This file contains preloaded vehicles models data from the API
// Do not edit manually - use 'npm run generate:vehicles-models-data' to regenerate

export const preloadedVehiclesModels: any = [
  {
    "marca": "FORD",
    "modelo": "ESCAPE",
    "busquedas": "44903"
  },
  {
    "marca": "HONDA",
    "modelo": "CR-V",
    "busquedas": "43947"
  },
  {
    "marca": "TOYOTA",
    "modelo": "COROLLA",
    "busquedas": "40777"
  },
  {
    "marca": "HONDA",
    "modelo": "CIVIC",
    "busquedas": "33904"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ELANTRA",
    "busquedas": "30484"
  },
  {
    "marca": "KIA",
    "modelo": "SORENTO",
    "busquedas": "14460"
  },
  {
    "marca": "TOYOTA",
    "modelo": "TACOMA",
    "busquedas": "12265"
  },
  {
    "marca": "NISSAN",
    "modelo": "FRONTIER",
    "busquedas": "11194"
  },
  {
    "marca": "FORD",
    "modelo": "EXPLORER",
    "busquedas": "10541"
  },
  {
    "marca": "TOYOTA",
    "modelo": "HILUX",
    "busquedas": "9647"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "L200",
    "busquedas": "9507"
  },
  {
    "marca": "TOYOTA",
    "modelo": "RAV4",
    "busquedas": "8319"
  },
  {
    "marca": "FORD",
    "modelo": "RANGER",
    "busquedas": "7624"
  },
  {
    "marca": "NISSAN",
    "modelo": "FRONTIER NP300 D23",
    "busquedas": "6373"
  },
  {
    "marca": "JEEP",
    "modelo": "PATRIOT",
    "busquedas": "6044"
  },
  {
    "marca": "FORD",
    "modelo": "FOCUS",
    "busquedas": "5484"
  },
  {
    "marca": "TOYOTA",
    "modelo": "4RUNNER",
    "busquedas": "5232"
  },
  {
    "marca": "ISUZU",
    "modelo": "D-MAX",
    "busquedas": "5047"
  },
  {
    "marca": "NISSAN",
    "modelo": "SENTRA",
    "busquedas": "5033"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "SANTA FE",
    "busquedas": "5018"
  },
  {
    "marca": "PONTIAC",
    "modelo": "VIBE",
    "busquedas": "4201"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "LANCER",
    "busquedas": "3976"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PICKUP",
    "busquedas": "3922"
  },
  {
    "marca": "KIA",
    "modelo": "SPORTAGE",
    "busquedas": "3880"
  },
  {
    "marca": "HONDA",
    "modelo": "FIT",
    "busquedas": "3754"
  },
  {
    "marca": "NISSAN",
    "modelo": "FRONTIER D22",
    "busquedas": "3552"
  },
  {
    "marca": "MAZDA",
    "modelo": "BT-50",
    "busquedas": "3509"
  },
  {
    "marca": "FORD",
    "modelo": "F-150",
    "busquedas": "3450"
  },
  {
    "marca": "HONDA",
    "modelo": "PILOT",
    "busquedas": "3390"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ACCENT",
    "busquedas": "3361"
  },
  {
    "marca": "HONDA",
    "modelo": "ACCORD",
    "busquedas": "2912"
  },
  {
    "marca": "NISSAN",
    "modelo": "ROGUE",
    "busquedas": "2885"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "TUCSON",
    "busquedas": "2863"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "COLORADO",
    "busquedas": "2844"
  },
  {
    "marca": "TOYOTA",
    "modelo": "LAND CRUISER PRADO",
    "busquedas": "2586"
  },
  {
    "marca": "MAZDA",
    "modelo": "3",
    "busquedas": "2421"
  },
  {
    "marca": "TOYOTA",
    "modelo": "MATRIX",
    "busquedas": "2186"
  },
  {
    "marca": "NISSAN",
    "modelo": "PATHFINDER",
    "busquedas": "2060"
  },
  {
    "marca": "JEEP",
    "modelo": "WRANGLER",
    "busquedas": "2044"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SPARK",
    "busquedas": "2023"
  },
  {
    "marca": "TOYOTA",
    "modelo": "HIACE",
    "busquedas": "1933"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "OUTLANDER",
    "busquedas": "1858"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MONTERO SPORT",
    "busquedas": "1823"
  },
  {
    "marca": "KIA",
    "modelo": "RIO",
    "busquedas": "1795"
  },
  {
    "marca": "TOYOTA",
    "modelo": "YARIS",
    "busquedas": "1683"
  },
  {
    "marca": "TOYOTA",
    "modelo": "CAMRY",
    "busquedas": "1547"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "SANTA FE SPORT",
    "busquedas": "1446"
  },
  {
    "marca": "NISSAN",
    "modelo": "ALTIMA",
    "busquedas": "1424"
  },
  {
    "marca": "KIA",
    "modelo": "SPECTRA",
    "busquedas": "1341"
  },
  {
    "marca": "HONDA",
    "modelo": "ODYSSEY",
    "busquedas": "1340"
  },
  {
    "marca": "JEEP",
    "modelo": "COMPASS",
    "busquedas": "1337"
  },
  {
    "marca": "MAZDA",
    "modelo": "TRIBUTE",
    "busquedas": "1334"
  },
  {
    "marca": "NISSAN",
    "modelo": "VERSA",
    "busquedas": "1329"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CRUZE",
    "busquedas": "1315"
  },
  {
    "marca": "MAZDA",
    "modelo": "PROTEGE",
    "busquedas": "1255"
  },
  {
    "marca": "TOYOTA",
    "modelo": "TERCEL",
    "busquedas": "1225"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "AMAROK",
    "busquedas": "1220"
  },
  {
    "marca": "JEEP",
    "modelo": "CHEROKEE",
    "busquedas": "1201"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "OUTLANDER SPORT",
    "busquedas": "1096"
  },
  {
    "marca": "NISSAN",
    "modelo": "NAVARA D40",
    "busquedas": "1052"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MIRAGE",
    "busquedas": "1018"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TAHOE",
    "busquedas": "978"
  },
  {
    "marca": "TOYOTA",
    "modelo": "TUNDRA",
    "busquedas": "974"
  },
  {
    "marca": "JEEP",
    "modelo": "GRAND CHEROKEE",
    "busquedas": "960"
  },
  {
    "marca": "FORD",
    "modelo": "EDGE",
    "busquedas": "940"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "H-100",
    "busquedas": "904"
  },
  {
    "marca": "MAZDA",
    "modelo": "6",
    "busquedas": "891"
  },
  {
    "marca": "ISUZU",
    "modelo": "RODEO",
    "busquedas": "888"
  },
  {
    "marca": "KIA",
    "modelo": "SOUL",
    "busquedas": "888"
  },
  {
    "marca": "TOYOTA",
    "modelo": "SIENNA",
    "busquedas": "872"
  },
  {
    "marca": "BMW",
    "modelo": "X3",
    "busquedas": "826"
  },
  {
    "marca": "HONDA",
    "modelo": "HR-V",
    "busquedas": "813"
  },
  {
    "marca": "KIA",
    "modelo": "PICANTO",
    "busquedas": "773"
  },
  {
    "marca": "KIA",
    "modelo": "SEPHIA",
    "busquedas": "759"
  },
  {
    "marca": "NISSAN",
    "modelo": "XTERRA",
    "busquedas": "753"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2900",
    "busquedas": "747"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MONTERO",
    "busquedas": "737"
  },
  {
    "marca": "TOYOTA",
    "modelo": "HIGHLANDER",
    "busquedas": "733"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "GALANT",
    "busquedas": "721"
  },
  {
    "marca": "NISSAN",
    "modelo": "PICKUP",
    "busquedas": "714"
  },
  {
    "marca": "DODGE",
    "modelo": "NEON",
    "busquedas": "711"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "SONATA",
    "busquedas": "692"
  },
  {
    "marca": "NISSAN",
    "modelo": "QASHQAI",
    "busquedas": "687"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "AVEO",
    "busquedas": "678"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TRAX",
    "busquedas": "673"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "S10",
    "busquedas": "667"
  },
  {
    "marca": "FORD",
    "modelo": "EXPEDITION",
    "busquedas": "663"
  },
  {
    "marca": "NISSAN",
    "modelo": "URVAN",
    "busquedas": "657"
  },
  {
    "marca": "TOYOTA",
    "modelo": "LAND CRUISER",
    "busquedas": "649"
  },
  {
    "marca": "HONDA",
    "modelo": "ELEMENT",
    "busquedas": "645"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2500",
    "busquedas": "637"
  },
  {
    "marca": "NISSAN",
    "modelo": "D21",
    "busquedas": "637"
  },
  {
    "marca": "BMW",
    "modelo": "X5",
    "busquedas": "619"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 1500",
    "busquedas": "603"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "NATIVA",
    "busquedas": "594"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "EQUINOX",
    "busquedas": "573"
  },
  {
    "marca": "FORD",
    "modelo": "MUSTANG",
    "busquedas": "556"
  },
  {
    "marca": "MINI",
    "modelo": "COOPER",
    "busquedas": "545"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GRAND STAREX",
    "busquedas": "545"
  },
  {
    "marca": "NISSAN",
    "modelo": "PATROL",
    "busquedas": "541"
  },
  {
    "marca": "BMW",
    "modelo": "328I",
    "busquedas": "492"
  },
  {
    "marca": "NISSAN",
    "modelo": "X-TRAIL",
    "busquedas": "454"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-7",
    "busquedas": "445"
  },
  {
    "marca": "SUZUKI",
    "modelo": "GRAND VITARA",
    "busquedas": "440"
  },
  {
    "marca": "ISUZU",
    "modelo": "PICKUP KB",
    "busquedas": "438"
  },
  {
    "marca": "RAM",
    "modelo": "1500",
    "busquedas": "415"
  },
  {
    "marca": "FORD",
    "modelo": "F-250 SUPER DUTY",
    "busquedas": "405"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TRACKER",
    "busquedas": "399"
  },
  {
    "marca": "MAZDA",
    "modelo": "BT-50 PRO",
    "busquedas": "362"
  },
  {
    "marca": "DODGE",
    "modelo": "DAKOTA",
    "busquedas": "360"
  },
  {
    "marca": "MAZDA",
    "modelo": "626",
    "busquedas": "354"
  },
  {
    "marca": "MERCURY",
    "modelo": "MARINER",
    "busquedas": "353"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "I10",
    "busquedas": "348"
  },
  {
    "marca": "NISSAN",
    "modelo": "MURANO",
    "busquedas": "345"
  },
  {
    "marca": "FORD",
    "modelo": "ESCORT",
    "busquedas": "344"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "JETTA",
    "busquedas": "338"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2200",
    "busquedas": "328"
  },
  {
    "marca": "HONDA",
    "modelo": "RIDGELINE",
    "busquedas": "328"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SONIC",
    "busquedas": "324"
  },
  {
    "marca": "JEEP",
    "modelo": "LIBERTY",
    "busquedas": "319"
  },
  {
    "marca": "GMC",
    "modelo": "CANYON",
    "busquedas": "307"
  },
  {
    "marca": "TOYOTA",
    "modelo": "ECHO",
    "busquedas": "302"
  },
  {
    "marca": "MAZDA",
    "modelo": "2",
    "busquedas": "294"
  },
  {
    "marca": "FORD",
    "modelo": "FIESTA",
    "busquedas": "293"
  },
  {
    "marca": "NISSAN",
    "modelo": "TIIDA",
    "busquedas": "290"
  },
  {
    "marca": "MAZDA",
    "modelo": "323",
    "busquedas": "288"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 2500",
    "busquedas": "276"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "EON",
    "busquedas": "271"
  },
  {
    "marca": "NISSAN",
    "modelo": "JUKE",
    "busquedas": "259"
  },
  {
    "marca": "JEEP",
    "modelo": "RENEGADE",
    "busquedas": "255"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "TIBURON",
    "busquedas": "254"
  },
  {
    "marca": "DODGE",
    "modelo": "CARAVAN",
    "busquedas": "253"
  },
  {
    "marca": "ISUZU",
    "modelo": "PICKUP",
    "busquedas": "252"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-5",
    "busquedas": "250"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "L300",
    "busquedas": "249"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 1500",
    "busquedas": "245"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "ECLIPSE",
    "busquedas": "231"
  },
  {
    "marca": "BMW",
    "modelo": "325I",
    "busquedas": "227"
  },
  {
    "marca": "NISSAN",
    "modelo": "KICKS",
    "busquedas": "221"
  },
  {
    "marca": "SCION",
    "modelo": "XB",
    "busquedas": "220"
  },
  {
    "marca": "NISSAN",
    "modelo": "URVAN NV350",
    "busquedas": "219"
  },
  {
    "marca": "FORD",
    "modelo": "EXPLORER SPORT TRAC",
    "busquedas": "214"
  },
  {
    "marca": "SUZUKI",
    "modelo": "FORENZA",
    "busquedas": "212"
  },
  {
    "marca": "SUBARU",
    "modelo": "FORESTER",
    "busquedas": "207"
  },
  {
    "marca": "NISSAN",
    "modelo": "NP300",
    "busquedas": "202"
  },
  {
    "marca": "SUZUKI",
    "modelo": "VITARA",
    "busquedas": "194"
  },
  {
    "marca": "SCION",
    "modelo": "XA",
    "busquedas": "192"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "PRIZM",
    "busquedas": "191"
  },
  {
    "marca": "SUZUKI",
    "modelo": "ESTEEM",
    "busquedas": "191"
  },
  {
    "marca": "KIA",
    "modelo": "FORTE",
    "busquedas": "191"
  },
  {
    "marca": "NISSAN",
    "modelo": "350Z",
    "busquedas": "190"
  },
  {
    "marca": "DODGE",
    "modelo": "GRAND CARAVAN",
    "busquedas": "189"
  },
  {
    "marca": "TOYOTA",
    "modelo": "CELICA",
    "busquedas": "185"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "AVALANCHE",
    "busquedas": "185"
  },
  {
    "marca": "KIA",
    "modelo": "OPTIMA",
    "busquedas": "181"
  },
  {
    "marca": "NISSAN",
    "modelo": "NV200",
    "busquedas": "178"
  },
  {
    "marca": "ACURA",
    "modelo": "RDX",
    "busquedas": "178"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2300",
    "busquedas": "174"
  },
  {
    "marca": "NISSAN",
    "modelo": "ARMADA",
    "busquedas": "173"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "TIGUAN",
    "busquedas": "166"
  },
  {
    "marca": "FORD",
    "modelo": "FUSION",
    "busquedas": "155"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CAPTIVA",
    "busquedas": "154"
  },
  {
    "marca": "HUMMER",
    "modelo": "H3",
    "busquedas": "151"
  },
  {
    "marca": "SUZUKI",
    "modelo": "SWIFT",
    "busquedas": "151"
  },
  {
    "marca": "SUZUKI",
    "modelo": "SIDEKICK",
    "busquedas": "150"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "H-1",
    "busquedas": "150"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "ENDEAVOR",
    "busquedas": "148"
  },
  {
    "marca": "TOYOTA",
    "modelo": "FORTUNER",
    "busquedas": "147"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "VELOSTER",
    "busquedas": "145"
  },
  {
    "marca": "ACURA",
    "modelo": "TL",
    "busquedas": "145"
  },
  {
    "marca": "NISSAN",
    "modelo": "720",
    "busquedas": "142"
  },
  {
    "marca": "DODGE",
    "modelo": "DART",
    "busquedas": "142"
  },
  {
    "marca": "SUZUKI",
    "modelo": "AERIO",
    "busquedas": "141"
  },
  {
    "marca": "FORD",
    "modelo": "TRANSIT CONNECT",
    "busquedas": "141"
  },
  {
    "marca": "SUZUKI",
    "modelo": "SX4",
    "busquedas": "139"
  },
  {
    "marca": "FORD",
    "modelo": "ECOSPORT",
    "busquedas": "139"
  },
  {
    "marca": "SCION",
    "modelo": "XD",
    "busquedas": "138"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GRAND I10",
    "busquedas": "137"
  },
  {
    "marca": "RAM",
    "modelo": "2500",
    "busquedas": "137"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-9",
    "busquedas": "134"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CAMARO",
    "busquedas": "134"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "CRETA",
    "busquedas": "129"
  },
  {
    "marca": "ACURA",
    "modelo": "TSX",
    "busquedas": "129"
  },
  {
    "marca": "TOYOTA",
    "modelo": "SEQUOIA",
    "busquedas": "126"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CAVALIER",
    "busquedas": "123"
  },
  {
    "marca": "NISSAN",
    "modelo": "TITAN",
    "busquedas": "121"
  },
  {
    "marca": "MAZDA",
    "modelo": "PROTEGE5",
    "busquedas": "119"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2000",
    "busquedas": "118"
  },
  {
    "marca": "DODGE",
    "modelo": "CALIBER",
    "busquedas": "111"
  },
  {
    "marca": "BMW",
    "modelo": "Z4",
    "busquedas": "107"
  },
  {
    "marca": "SUBARU",
    "modelo": "IMPREZA",
    "busquedas": "107"
  },
  {
    "marca": "DODGE",
    "modelo": "JOURNEY",
    "busquedas": "106"
  },
  {
    "marca": "SUBARU",
    "modelo": "OUTBACK",
    "busquedas": "105"
  },
  {
    "marca": "ACURA",
    "modelo": "RSX",
    "busquedas": "105"
  },
  {
    "marca": "SATURN",
    "modelo": "VUE",
    "busquedas": "105"
  },
  {
    "marca": "MAZDA",
    "modelo": "5",
    "busquedas": "102"
  },
  {
    "marca": "FORD",
    "modelo": "F-350 SUPER DUTY",
    "busquedas": "102"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "PT CRUISER",
    "busquedas": "101"
  },
  {
    "marca": "NISSAN",
    "modelo": "MAXIMA",
    "busquedas": "91"
  },
  {
    "marca": "ISUZU",
    "modelo": "TROOPER",
    "busquedas": "91"
  },
  {
    "marca": "SUZUKI",
    "modelo": "APV",
    "busquedas": "89"
  },
  {
    "marca": "NISSAN",
    "modelo": "NV350 URVAN",
    "busquedas": "86"
  },
  {
    "marca": "SCION",
    "modelo": "TC",
    "busquedas": "86"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "TERRACAN",
    "busquedas": "85"
  },
  {
    "marca": "ACURA",
    "modelo": "MDX",
    "busquedas": "85"
  },
  {
    "marca": "BMW",
    "modelo": "X1",
    "busquedas": "84"
  },
  {
    "marca": "BMW",
    "modelo": "335I",
    "busquedas": "83"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "PASSAT",
    "busquedas": "83"
  },
  {
    "marca": "SUBARU",
    "modelo": "LEGACY",
    "busquedas": "82"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "N300",
    "busquedas": "81"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 3500",
    "busquedas": "81"
  },
  {
    "marca": "TOYOTA",
    "modelo": "T100",
    "busquedas": "81"
  },
  {
    "marca": "GEO",
    "modelo": "PRIZM",
    "busquedas": "80"
  },
  {
    "marca": "LEXUS",
    "modelo": "RX300",
    "busquedas": "80"
  },
  {
    "marca": "DODGE",
    "modelo": "DURANGO",
    "busquedas": "79"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "MATRIX",
    "busquedas": "78"
  },
  {
    "marca": "ISUZU",
    "modelo": "MU-X",
    "busquedas": "78"
  },
  {
    "marca": "MAZDA",
    "modelo": "MPV",
    "busquedas": "76"
  },
  {
    "marca": "NISSAN",
    "modelo": "QUEST",
    "busquedas": "76"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 1500",
    "busquedas": "75"
  },
  {
    "marca": "LEXUS",
    "modelo": "GX470",
    "busquedas": "75"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "VERACRUZ",
    "busquedas": "74"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ELANTRA GT",
    "busquedas": "73"
  },
  {
    "marca": "BMW",
    "modelo": "X6",
    "busquedas": "72"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "BLAZER",
    "busquedas": "72"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SUBURBAN 1500",
    "busquedas": "72"
  },
  {
    "marca": "VOLVO",
    "modelo": "S60",
    "busquedas": "71"
  },
  {
    "marca": "INFINITI",
    "modelo": "QX60",
    "busquedas": "71"
  },
  {
    "marca": "ACURA",
    "modelo": "ILX",
    "busquedas": "70"
  },
  {
    "marca": "SUZUKI",
    "modelo": "JIMNY",
    "busquedas": "70"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "MALIBU",
    "busquedas": "70"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "BEAT",
    "busquedas": "69"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "METRO",
    "busquedas": "69"
  },
  {
    "marca": "AUDI",
    "modelo": "Q7",
    "busquedas": "67"
  },
  {
    "marca": "HONDA",
    "modelo": "CITY",
    "busquedas": "67"
  },
  {
    "marca": "CADILLAC",
    "modelo": "ESCALADE",
    "busquedas": "66"
  },
  {
    "marca": "ACURA",
    "modelo": "INTEGRA",
    "busquedas": "66"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SUBURBAN",
    "busquedas": "66"
  },
  {
    "marca": "NISSAN",
    "modelo": "ALMERA",
    "busquedas": "65"
  },
  {
    "marca": "BMW",
    "modelo": "328I XDRIVE",
    "busquedas": "64"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TRAVERSE",
    "busquedas": "64"
  },
  {
    "marca": "RAM",
    "modelo": "3500",
    "busquedas": "62"
  },
  {
    "marca": "TOYOTA",
    "modelo": "FJ CRUISER",
    "busquedas": "60"
  },
  {
    "marca": "BMW",
    "modelo": "528I",
    "busquedas": "59"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "TOWN & COUNTRY",
    "busquedas": "57"
  },
  {
    "marca": "VOLVO",
    "modelo": "S40",
    "busquedas": "56"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CAPTIVA SPORT",
    "busquedas": "56"
  },
  {
    "marca": "FORD",
    "modelo": "F-250",
    "busquedas": "54"
  },
  {
    "marca": "MINI",
    "modelo": "COOPER COUNTRYMAN",
    "busquedas": "53"
  },
  {
    "marca": "PORSCHE",
    "modelo": "CAYENNE",
    "busquedas": "52"
  },
  {
    "marca": "GMC",
    "modelo": "ACADIA",
    "busquedas": "51"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "STAREX",
    "busquedas": "50"
  },
  {
    "marca": "FORD",
    "modelo": "TAURUS",
    "busquedas": "50"
  },
  {
    "marca": "TOYOTA",
    "modelo": "LAND CRUISER PICKUP",
    "busquedas": "50"
  },
  {
    "marca": "MAZDA",
    "modelo": "B3000",
    "busquedas": "49"
  },
  {
    "marca": "VOLVO",
    "modelo": "XC90",
    "busquedas": "49"
  },
  {
    "marca": "JEEP",
    "modelo": "GLADIATOR",
    "busquedas": "49"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 2500 HD",
    "busquedas": "48"
  },
  {
    "marca": "TOYOTA",
    "modelo": "AVALON",
    "busquedas": "48"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "OPTRA",
    "busquedas": "47"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "BEETLE",
    "busquedas": "46"
  },
  {
    "marca": "SUZUKI",
    "modelo": "XL-7",
    "busquedas": "46"
  },
  {
    "marca": "LINCOLN",
    "modelo": "MKX",
    "busquedas": "44"
  },
  {
    "marca": "DODGE",
    "modelo": "AVENGER",
    "busquedas": "44"
  },
  {
    "marca": "GMC",
    "modelo": "SONOMA",
    "busquedas": "43"
  },
  {
    "marca": "KIA",
    "modelo": "SEDONA",
    "busquedas": "43"
  },
  {
    "marca": "KIA",
    "modelo": "PREGIO",
    "busquedas": "43"
  },
  {
    "marca": "TOYOTA",
    "modelo": "AVENSIS",
    "busquedas": "42"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "VENTURE",
    "busquedas": "41"
  },
  {
    "marca": "KIA",
    "modelo": "SPECTRA5",
    "busquedas": "40"
  },
  {
    "marca": "NISSAN",
    "modelo": "NP300 FRONTIER",
    "busquedas": "39"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TRAILBLAZER",
    "busquedas": "39"
  },
  {
    "marca": "ISUZU",
    "modelo": "I-290",
    "busquedas": "38"
  },
  {
    "marca": "AUDI",
    "modelo": "A4",
    "busquedas": "37"
  },
  {
    "marca": "GMC",
    "modelo": "ENVOY",
    "busquedas": "37"
  },
  {
    "marca": "DODGE",
    "modelo": "NITRO",
    "busquedas": "36"
  },
  {
    "marca": "SUZUKI",
    "modelo": "SAMURAI",
    "busquedas": "34"
  },
  {
    "marca": "GMC",
    "modelo": "YUKON",
    "busquedas": "34"
  },
  {
    "marca": "ISUZU",
    "modelo": "HOMBRE",
    "busquedas": "34"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GENESIS COUPE",
    "busquedas": "33"
  },
  {
    "marca": "LINCOLN",
    "modelo": "AVIATOR",
    "busquedas": "33"
  },
  {
    "marca": "ISUZU",
    "modelo": "RODEO SPORT",
    "busquedas": "33"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "TOUAREG",
    "busquedas": "33"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MIGHTY MAX",
    "busquedas": "33"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C230",
    "busquedas": "31"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "IMPALA",
    "busquedas": "31"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ATOS",
    "busquedas": "30"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "PACIFICA",
    "busquedas": "30"
  },
  {
    "marca": "FIAT",
    "modelo": "500",
    "busquedas": "30"
  },
  {
    "marca": "NISSAN",
    "modelo": "ROGUE SPORT",
    "busquedas": "30"
  },
  {
    "marca": "LEXUS",
    "modelo": "GX460",
    "busquedas": "30"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "DISCOVERY",
    "busquedas": "30"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "GOLF",
    "busquedas": "30"
  },
  {
    "marca": "BMW",
    "modelo": "330I",
    "busquedas": "30"
  },
  {
    "marca": "PONTIAC",
    "modelo": "SOLSTICE",
    "busquedas": "30"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "AVALANCHE 1500",
    "busquedas": "30"
  },
  {
    "marca": "BMW",
    "modelo": "320I",
    "busquedas": "29"
  },
  {
    "marca": "DODGE",
    "modelo": "CHARGER",
    "busquedas": "29"
  },
  {
    "marca": "FORD",
    "modelo": "FLEX",
    "busquedas": "29"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MIRAGE G4",
    "busquedas": "29"
  },
  {
    "marca": "BMW",
    "modelo": "128I",
    "busquedas": "28"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ELANTRA COUPE",
    "busquedas": "28"
  },
  {
    "marca": "GEO",
    "modelo": "METRO",
    "busquedas": "28"
  },
  {
    "marca": "HONDA",
    "modelo": "PASSPORT",
    "busquedas": "28"
  },
  {
    "marca": "INFINITI",
    "modelo": "QX4",
    "busquedas": "28"
  },
  {
    "marca": "BMW",
    "modelo": "Z3",
    "busquedas": "27"
  },
  {
    "marca": "INFINITI",
    "modelo": "FX35",
    "busquedas": "27"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "CC",
    "busquedas": "27"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "COBALT",
    "busquedas": "27"
  },
  {
    "marca": "BMW",
    "modelo": "330CI",
    "busquedas": "27"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "200",
    "busquedas": "27"
  },
  {
    "marca": "SCION",
    "modelo": "IQ",
    "busquedas": "26"
  },
  {
    "marca": "SUBARU",
    "modelo": "BAJA",
    "busquedas": "26"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "HHR",
    "busquedas": "26"
  },
  {
    "marca": "BMW",
    "modelo": "330XI",
    "busquedas": "25"
  },
  {
    "marca": "GMC",
    "modelo": "TERRAIN",
    "busquedas": "25"
  },
  {
    "marca": "HUMMER",
    "modelo": "H2",
    "busquedas": "25"
  },
  {
    "marca": "LINCOLN",
    "modelo": "NAVIGATOR",
    "busquedas": "24"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "EXPRESS 1500",
    "busquedas": "24"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2600",
    "busquedas": "24"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "ML320",
    "busquedas": "23"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 2500 HD",
    "busquedas": "23"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "N400",
    "busquedas": "23"
  },
  {
    "marca": "BMW",
    "modelo": "323I",
    "busquedas": "23"
  },
  {
    "marca": "TOYOTA",
    "modelo": "CRESSIDA",
    "busquedas": "23"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "GROOVE",
    "busquedas": "22"
  },
  {
    "marca": "MAZDA",
    "modelo": "MIATA",
    "busquedas": "22"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "POLO",
    "busquedas": "22"
  },
  {
    "marca": "TOYOTA",
    "modelo": "STARLET",
    "busquedas": "22"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GRACE",
    "busquedas": "22"
  },
  {
    "marca": "ISUZU",
    "modelo": "I-280",
    "busquedas": "22"
  },
  {
    "marca": "SUZUKI",
    "modelo": "CELERIO",
    "busquedas": "21"
  },
  {
    "marca": "FORD",
    "modelo": "E-350 SUPER DUTY",
    "busquedas": "21"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "300",
    "busquedas": "21"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "VENUE",
    "busquedas": "21"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "RANGE ROVER",
    "busquedas": "21"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PRIUS",
    "busquedas": "21"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 2500",
    "busquedas": "20"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "E320",
    "busquedas": "20"
  },
  {
    "marca": "TOYOTA",
    "modelo": "URBAN CRUISER",
    "busquedas": "20"
  },
  {
    "marca": "RENAULT",
    "modelo": "KOLEOS",
    "busquedas": "19"
  },
  {
    "marca": "PONTIAC",
    "modelo": "TORRENT",
    "busquedas": "19"
  },
  {
    "marca": "DODGE",
    "modelo": "CHALLENGER",
    "busquedas": "19"
  },
  {
    "marca": "MAZDA",
    "modelo": "B4000",
    "busquedas": "19"
  },
  {
    "marca": "NISSAN",
    "modelo": "CUBE",
    "busquedas": "19"
  },
  {
    "marca": "INFINITI",
    "modelo": "G35",
    "busquedas": "18"
  },
  {
    "marca": "FORD",
    "modelo": "WINDSTAR",
    "busquedas": "18"
  },
  {
    "marca": "PONTIAC",
    "modelo": "G6",
    "busquedas": "18"
  },
  {
    "marca": "BMW",
    "modelo": "525I",
    "busquedas": "18"
  },
  {
    "marca": "FORD",
    "modelo": "BRONCO",
    "busquedas": "18"
  },
  {
    "marca": "FORD",
    "modelo": "EXCURSION",
    "busquedas": "18"
  },
  {
    "marca": "LEXUS",
    "modelo": "LX470",
    "busquedas": "18"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "RAIDER",
    "busquedas": "17"
  },
  {
    "marca": "BMW",
    "modelo": "535I",
    "busquedas": "17"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C250",
    "busquedas": "17"
  },
  {
    "marca": "SATURN",
    "modelo": "SL1",
    "busquedas": "17"
  },
  {
    "marca": "SATURN",
    "modelo": "SL2",
    "busquedas": "17"
  },
  {
    "marca": "ISUZU",
    "modelo": "AMIGO",
    "busquedas": "17"
  },
  {
    "marca": "PLYMOUTH",
    "modelo": "VOYAGER",
    "busquedas": "16"
  },
  {
    "marca": "HONDA",
    "modelo": "CROSSTOUR",
    "busquedas": "16"
  },
  {
    "marca": "BMW",
    "modelo": "325XI",
    "busquedas": "16"
  },
  {
    "marca": "NISSAN",
    "modelo": "240SX",
    "busquedas": "16"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "EXCEL",
    "busquedas": "16"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "GTI",
    "busquedas": "16"
  },
  {
    "marca": "FORD",
    "modelo": "FIGO",
    "busquedas": "16"
  },
  {
    "marca": "PORSCHE",
    "modelo": "BOXSTER",
    "busquedas": "15"
  },
  {
    "marca": "DAIHATSU",
    "modelo": "TERIOS",
    "busquedas": "15"
  },
  {
    "marca": "LEXUS",
    "modelo": "RX350",
    "busquedas": "15"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "RANGE ROVER SPORT",
    "busquedas": "15"
  },
  {
    "marca": "BMW",
    "modelo": "318I",
    "busquedas": "15"
  },
  {
    "marca": "BMW",
    "modelo": "530I",
    "busquedas": "15"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-3",
    "busquedas": "15"
  },
  {
    "marca": "AUDI",
    "modelo": "Q5",
    "busquedas": "15"
  },
  {
    "marca": "JAGUAR",
    "modelo": "X-TYPE",
    "busquedas": "15"
  },
  {
    "marca": "HONDA",
    "modelo": "CR-Z",
    "busquedas": "14"
  },
  {
    "marca": "AUDI",
    "modelo": "TT",
    "busquedas": "14"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "ECLIPSE CROSS",
    "busquedas": "14"
  },
  {
    "marca": "LEXUS",
    "modelo": "IS250",
    "busquedas": "14"
  },
  {
    "marca": "LEXUS",
    "modelo": "IS300",
    "busquedas": "14"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 3500",
    "busquedas": "14"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C300",
    "busquedas": "14"
  },
  {
    "marca": "MERCURY",
    "modelo": "TRACER",
    "busquedas": "13"
  },
  {
    "marca": "DAIHATSU",
    "modelo": "SIRION",
    "busquedas": "13"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "CROSSFOX",
    "busquedas": "13"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO",
    "busquedas": "13"
  },
  {
    "marca": "BMW",
    "modelo": "325CI",
    "busquedas": "13"
  },
  {
    "marca": "CADILLAC",
    "modelo": "ESCALADE ESV",
    "busquedas": "13"
  },
  {
    "marca": "TOYOTA",
    "modelo": "LAND CRUISER II",
    "busquedas": "13"
  },
  {
    "marca": "PONTIAC",
    "modelo": "SUNFIRE",
    "busquedas": "13"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CMV",
    "busquedas": "13"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "SAVEIRO",
    "busquedas": "13"
  },
  {
    "marca": "JEEP",
    "modelo": "COMMANDER",
    "busquedas": "12"
  },
  {
    "marca": "NISSAN",
    "modelo": "PATHFINDER ARMADA",
    "busquedas": "12"
  },
  {
    "marca": "MERCURY",
    "modelo": "MOUNTAINEER",
    "busquedas": "12"
  },
  {
    "marca": "INFINITI",
    "modelo": "JX35",
    "busquedas": "12"
  },
  {
    "marca": "KIA",
    "modelo": "SELTOS",
    "busquedas": "12"
  },
  {
    "marca": "FORD",
    "modelo": "TRANSIT-150",
    "busquedas": "12"
  },
  {
    "marca": "TOYOTA",
    "modelo": "VAN",
    "busquedas": "12"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "R350",
    "busquedas": "12"
  },
  {
    "marca": "LEXUS",
    "modelo": "ES330",
    "busquedas": "12"
  },
  {
    "marca": "KIA",
    "modelo": "CERATO",
    "busquedas": "12"
  },
  {
    "marca": "BMW",
    "modelo": "328XI",
    "busquedas": "12"
  },
  {
    "marca": "BMW",
    "modelo": "640I",
    "busquedas": "12"
  },
  {
    "marca": "AUDI",
    "modelo": "S4",
    "busquedas": "12"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "ML350",
    "busquedas": "12"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CORVETTE",
    "busquedas": "12"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "FREELANDER",
    "busquedas": "12"
  },
  {
    "marca": "SUBARU",
    "modelo": "CROSSTREK",
    "busquedas": "11"
  },
  {
    "marca": "JMC",
    "modelo": "VIGUS",
    "busquedas": "11"
  },
  {
    "marca": "FORD",
    "modelo": "FREESTAR",
    "busquedas": "11"
  },
  {
    "marca": "TOYOTA",
    "modelo": "COASTER",
    "busquedas": "11"
  },
  {
    "marca": "FORD",
    "modelo": "TRANSIT-250",
    "busquedas": "11"
  },
  {
    "marca": "BUICK",
    "modelo": "ENCORE",
    "busquedas": "11"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PREVIA",
    "busquedas": "11"
  },
  {
    "marca": "KIA",
    "modelo": "RONDO",
    "busquedas": "11"
  },
  {
    "marca": "CADILLAC",
    "modelo": "CTS",
    "busquedas": "11"
  },
  {
    "marca": "KIA",
    "modelo": "CARNIVAL",
    "busquedas": "11"
  },
  {
    "marca": "INFINITI",
    "modelo": "QX56",
    "busquedas": "11"
  },
  {
    "marca": "CADILLAC",
    "modelo": "XT5",
    "busquedas": "10"
  },
  {
    "marca": "BMW",
    "modelo": "X4",
    "busquedas": "10"
  },
  {
    "marca": "FORD",
    "modelo": "CONTOUR",
    "busquedas": "10"
  },
  {
    "marca": "FORD",
    "modelo": "E-350 ECONOLINE",
    "busquedas": "10"
  },
  {
    "marca": "INFINITI",
    "modelo": "QX80",
    "busquedas": "10"
  },
  {
    "marca": "RENAULT",
    "modelo": "CLIO",
    "busquedas": "10"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "ASTRO",
    "busquedas": "10"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GL450",
    "busquedas": "10"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 3500 HD",
    "busquedas": "10"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SUBURBAN 2500",
    "busquedas": "10"
  },
  {
    "marca": "SUZUKI",
    "modelo": "S-PRESSO",
    "busquedas": "10"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLK350",
    "busquedas": "10"
  },
  {
    "marca": "LEXUS",
    "modelo": "ES300",
    "busquedas": "10"
  },
  {
    "marca": "GMC",
    "modelo": "SAFARI",
    "busquedas": "10"
  },
  {
    "marca": "VOLVO",
    "modelo": "S80",
    "busquedas": "10"
  },
  {
    "marca": "LEXUS",
    "modelo": "RX330",
    "busquedas": "10"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CITY EXPRESS",
    "busquedas": "9"
  },
  {
    "marca": "CADILLAC",
    "modelo": "SRX",
    "busquedas": "9"
  },
  {
    "marca": "BMW",
    "modelo": "325ES",
    "busquedas": "9"
  },
  {
    "marca": "KIA",
    "modelo": "SONET",
    "busquedas": "9"
  },
  {
    "marca": "SUZUKI",
    "modelo": "IGNIS",
    "busquedas": "9"
  },
  {
    "marca": "VOLVO",
    "modelo": "C70",
    "busquedas": "9"
  },
  {
    "marca": "GMC",
    "modelo": "JIMMY",
    "busquedas": "9"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "SEBRING",
    "busquedas": "9"
  },
  {
    "marca": "DODGE",
    "modelo": "STRATUS",
    "busquedas": "9"
  },
  {
    "marca": "SUZUKI",
    "modelo": "EQUATOR",
    "busquedas": "9"
  },
  {
    "marca": "KIA",
    "modelo": "CARENS",
    "busquedas": "9"
  },
  {
    "marca": "FORD",
    "modelo": "E-150",
    "busquedas": "9"
  },
  {
    "marca": "PORSCHE",
    "modelo": "MACAN",
    "busquedas": "9"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "LR2",
    "busquedas": "9"
  },
  {
    "marca": "KIA",
    "modelo": "FORTE KOUP",
    "busquedas": "8"
  },
  {
    "marca": "LEXUS",
    "modelo": "LX450",
    "busquedas": "8"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA",
    "busquedas": "8"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ENTOURAGE",
    "busquedas": "8"
  },
  {
    "marca": "SUZUKI",
    "modelo": "RENO",
    "busquedas": "8"
  },
  {
    "marca": "TOYOTA",
    "modelo": "RUSH",
    "busquedas": "8"
  },
  {
    "marca": "FORD",
    "modelo": "BRONCO II",
    "busquedas": "8"
  },
  {
    "marca": "BMW",
    "modelo": "528I XDRIVE",
    "busquedas": "8"
  },
  {
    "marca": "SUBARU",
    "modelo": "BRAT",
    "busquedas": "8"
  },
  {
    "marca": "LEXUS",
    "modelo": "GS300",
    "busquedas": "8"
  },
  {
    "marca": "DAEWOO",
    "modelo": "LANOS",
    "busquedas": "8"
  },
  {
    "marca": "GMC",
    "modelo": "SAVANA 2500",
    "busquedas": "8"
  },
  {
    "marca": "KIA",
    "modelo": "SOLUTO",
    "busquedas": "8"
  },
  {
    "marca": "PORSCHE",
    "modelo": "PANAMERA",
    "busquedas": "8"
  },
  {
    "marca": "GEO",
    "modelo": "TRACKER",
    "busquedas": "8"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "E350",
    "busquedas": "7"
  },
  {
    "marca": "SUBARU",
    "modelo": "BRZ",
    "busquedas": "7"
  },
  {
    "marca": "ISUZU",
    "modelo": "I-MARK",
    "busquedas": "7"
  },
  {
    "marca": "BMW",
    "modelo": "318IS",
    "busquedas": "7"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MONTERO IO",
    "busquedas": "7"
  },
  {
    "marca": "SATURN",
    "modelo": "ION",
    "busquedas": "7"
  },
  {
    "marca": "GMC",
    "modelo": "S15",
    "busquedas": "7"
  },
  {
    "marca": "BMW",
    "modelo": "650I",
    "busquedas": "7"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "ASX",
    "busquedas": "7"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C350",
    "busquedas": "7"
  },
  {
    "marca": "VOLVO",
    "modelo": "S70",
    "busquedas": "7"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 3500 VAN",
    "busquedas": "6"
  },
  {
    "marca": "FORD",
    "modelo": "E-250",
    "busquedas": "6"
  },
  {
    "marca": "NISSAN",
    "modelo": "QASHQAI+2",
    "busquedas": "6"
  },
  {
    "marca": "RAM",
    "modelo": "700",
    "busquedas": "6"
  },
  {
    "marca": "FORD",
    "modelo": "EXPLORER SPORT",
    "busquedas": "6"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "PALISADE",
    "busquedas": "6"
  },
  {
    "marca": "TOYOTA",
    "modelo": "MR2",
    "busquedas": "6"
  },
  {
    "marca": "HONDA",
    "modelo": "S2000",
    "busquedas": "6"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "VOYAGER",
    "busquedas": "6"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SPARK CLASSIC",
    "busquedas": "6"
  },
  {
    "marca": "PLYMOUTH",
    "modelo": "NEON",
    "busquedas": "6"
  },
  {
    "marca": "FORD",
    "modelo": "E-350 ECONOLINE CLUB WAGON",
    "busquedas": "6"
  },
  {
    "marca": "TOYOTA",
    "modelo": "SOLARA",
    "busquedas": "6"
  },
  {
    "marca": "HONDA",
    "modelo": "INSIGHT",
    "busquedas": "6"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "300D",
    "busquedas": "6"
  },
  {
    "marca": "FORD",
    "modelo": "TRANSIT-350",
    "busquedas": "6"
  },
  {
    "marca": "NISSAN",
    "modelo": "TITAN XD",
    "busquedas": "6"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-30",
    "busquedas": "6"
  },
  {
    "marca": "LEXUS",
    "modelo": "LS400",
    "busquedas": "6"
  },
  {
    "marca": "MASERATI",
    "modelo": "QUATTROPORTE",
    "busquedas": "6"
  },
  {
    "marca": "BUICK",
    "modelo": "RENDEZVOUS",
    "busquedas": "6"
  },
  {
    "marca": "NISSAN",
    "modelo": "VERSA NOTE",
    "busquedas": "6"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C320",
    "busquedas": "6"
  },
  {
    "marca": "LEXUS",
    "modelo": "GS350",
    "busquedas": "5"
  },
  {
    "marca": "DODGE",
    "modelo": "ATTITUDE",
    "busquedas": "5"
  },
  {
    "marca": "SUBARU",
    "modelo": "TRIBECA",
    "busquedas": "5"
  },
  {
    "marca": "PONTIAC",
    "modelo": "G5",
    "busquedas": "5"
  },
  {
    "marca": "FORD",
    "modelo": "BRONCO SPORT",
    "busquedas": "5"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "RABBIT",
    "busquedas": "5"
  },
  {
    "marca": "NISSAN",
    "modelo": "STANZA",
    "busquedas": "5"
  },
  {
    "marca": "ACURA",
    "modelo": "TLX",
    "busquedas": "5"
  },
  {
    "marca": "DODGE",
    "modelo": "RAIDER",
    "busquedas": "5"
  },
  {
    "marca": "SATURN",
    "modelo": "LS1",
    "busquedas": "5"
  },
  {
    "marca": "FORD",
    "modelo": "TAURUS X",
    "busquedas": "5"
  },
  {
    "marca": "JAC",
    "modelo": "X200",
    "busquedas": "5"
  },
  {
    "marca": "VOLVO",
    "modelo": "XC70",
    "busquedas": "5"
  },
  {
    "marca": "BUICK",
    "modelo": "LACROSSE",
    "busquedas": "5"
  },
  {
    "marca": "TOYOTA",
    "modelo": "CORONA",
    "busquedas": "5"
  },
  {
    "marca": "DAEWOO",
    "modelo": "NUBIRA",
    "busquedas": "5"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLS450",
    "busquedas": "5"
  },
  {
    "marca": "BUICK",
    "modelo": "ENCLAVE",
    "busquedas": "5"
  },
  {
    "marca": "TOYOTA",
    "modelo": "LITE ACE",
    "busquedas": "5"
  },
  {
    "marca": "HONDA",
    "modelo": "PRELUDE",
    "busquedas": "5"
  },
  {
    "marca": "RAM",
    "modelo": "1500 CLASSIC",
    "busquedas": "5"
  },
  {
    "marca": "ACURA",
    "modelo": "RL",
    "busquedas": "4"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "CLK430",
    "busquedas": "4"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "EXPRESS 2500",
    "busquedas": "4"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "DISCOVERY SPORT",
    "busquedas": "4"
  },
  {
    "marca": "LEXUS",
    "modelo": "LX570",
    "busquedas": "4"
  },
  {
    "marca": "NISSAN",
    "modelo": "370Z",
    "busquedas": "4"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SLK230",
    "busquedas": "4"
  },
  {
    "marca": "FORD",
    "modelo": "TRANSIT",
    "busquedas": "4"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 2500",
    "busquedas": "4"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "DEFENDER",
    "busquedas": "4"
  },
  {
    "marca": "PLYMOUTH",
    "modelo": "GRAND VOYAGER",
    "busquedas": "4"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "MALIBU LIMITED",
    "busquedas": "4"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "BORA",
    "busquedas": "4"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "ATLAS",
    "busquedas": "4"
  },
  {
    "marca": "SUBARU",
    "modelo": "XV CROSSTREK",
    "busquedas": "4"
  },
  {
    "marca": "PONTIAC",
    "modelo": "G3",
    "busquedas": "4"
  },
  {
    "marca": "BMW",
    "modelo": "335D",
    "busquedas": "4"
  },
  {
    "marca": "INFINITI",
    "modelo": "EX35",
    "busquedas": "4"
  },
  {
    "marca": "TOYOTA",
    "modelo": "VENZA",
    "busquedas": "4"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 2500 VAN",
    "busquedas": "4"
  },
  {
    "marca": "PONTIAC",
    "modelo": "GRAND PRIX",
    "busquedas": "4"
  },
  {
    "marca": "FORD",
    "modelo": "E-150 ECONOLINE",
    "busquedas": "4"
  },
  {
    "marca": "BMW",
    "modelo": "328CI",
    "busquedas": "4"
  },
  {
    "marca": "KIA",
    "modelo": "RIO5",
    "busquedas": "4"
  },
  {
    "marca": "TOYOTA",
    "modelo": "YARIS IA",
    "busquedas": "4"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "OUTLANDER PHEV",
    "busquedas": "4"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "UPLANDER",
    "busquedas": "3"
  },
  {
    "marca": "FIAT",
    "modelo": "SIENA",
    "busquedas": "3"
  },
  {
    "marca": "GMC",
    "modelo": "ENVOY XL",
    "busquedas": "3"
  },
  {
    "marca": "MAZDA",
    "modelo": "RX-8",
    "busquedas": "3"
  },
  {
    "marca": "AUDI",
    "modelo": "A3",
    "busquedas": "3"
  },
  {
    "marca": "SATURN",
    "modelo": "SL",
    "busquedas": "3"
  },
  {
    "marca": "MAZDA",
    "modelo": "MX-5",
    "busquedas": "3"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "LR3",
    "busquedas": "3"
  },
  {
    "marca": "BMW",
    "modelo": "X7",
    "busquedas": "3"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SUBURBAN 3500 HD",
    "busquedas": "3"
  },
  {
    "marca": "DODGE",
    "modelo": "SPRINTER 2500",
    "busquedas": "3"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "E550",
    "busquedas": "3"
  },
  {
    "marca": "SUBARU",
    "modelo": "WRX",
    "busquedas": "3"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "K1500",
    "busquedas": "3"
  },
  {
    "marca": "SATURN",
    "modelo": "OUTLOOK",
    "busquedas": "3"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 1500 VAN",
    "busquedas": "3"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 1500 HD",
    "busquedas": "3"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 1500 LD",
    "busquedas": "3"
  },
  {
    "marca": "VOLVO",
    "modelo": "XC60",
    "busquedas": "3"
  },
  {
    "marca": "FORD",
    "modelo": "F-350",
    "busquedas": "3"
  },
  {
    "marca": "BMW",
    "modelo": "335XI",
    "busquedas": "3"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C280",
    "busquedas": "3"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C240",
    "busquedas": "3"
  },
  {
    "marca": "FORD",
    "modelo": "AEROSTAR",
    "busquedas": "3"
  },
  {
    "marca": "BMW",
    "modelo": "335IS",
    "busquedas": "3"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "3000GT",
    "busquedas": "3"
  },
  {
    "marca": "MAHINDRA",
    "modelo": "SCORPIO",
    "busquedas": "3"
  },
  {
    "marca": "FORD",
    "modelo": "E-150 ECONOLINE CLUB WAGON",
    "busquedas": "3"
  },
  {
    "marca": "BMW",
    "modelo": "540I",
    "busquedas": "3"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "MONTE CARLO",
    "busquedas": "3"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "EXPRESS 3500",
    "busquedas": "3"
  },
  {
    "marca": "NISSAN",
    "modelo": "ROGUE SELECT",
    "busquedas": "3"
  },
  {
    "marca": "MINI",
    "modelo": "COOPER CLUBMAN",
    "busquedas": "3"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "CABRIO",
    "busquedas": "3"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CORSA",
    "busquedas": "3"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GL320",
    "busquedas": "2"
  },
  {
    "marca": "JIM",
    "modelo": "REMAX",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLC300",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "AVEO5",
    "busquedas": "2"
  },
  {
    "marca": "SCION",
    "modelo": "IA",
    "busquedas": "2"
  },
  {
    "marca": "EAGLE",
    "modelo": "TALON",
    "busquedas": "2"
  },
  {
    "marca": "SUZUKI",
    "modelo": "VERONA",
    "busquedas": "2"
  },
  {
    "marca": "SATURN",
    "modelo": "SKY",
    "busquedas": "2"
  },
  {
    "marca": "SATURN",
    "modelo": "SC1",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "E55 AMG",
    "busquedas": "2"
  },
  {
    "marca": "JAGUAR",
    "modelo": "XF",
    "busquedas": "2"
  },
  {
    "marca": "SATURN",
    "modelo": "AURA",
    "busquedas": "2"
  },
  {
    "marca": "TOYOTA",
    "modelo": "COROLLA CROSS",
    "busquedas": "2"
  },
  {
    "marca": "KIA",
    "modelo": "FORTE5",
    "busquedas": "2"
  },
  {
    "marca": "BMW",
    "modelo": "323CI",
    "busquedas": "2"
  },
  {
    "marca": "FORD",
    "modelo": "FREESTYLE",
    "busquedas": "2"
  },
  {
    "marca": "FORD",
    "modelo": "FIVE HUNDRED",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "CLA250",
    "busquedas": "2"
  },
  {
    "marca": "BMW",
    "modelo": "228I GRAN COUPE",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C200",
    "busquedas": "2"
  },
  {
    "marca": "KIA",
    "modelo": "NIRO",
    "busquedas": "2"
  },
  {
    "marca": "ISUZU",
    "modelo": "AXIOM",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "NOVA",
    "busquedas": "2"
  },
  {
    "marca": "FORD",
    "modelo": "C-MAX",
    "busquedas": "2"
  },
  {
    "marca": "PONTIAC",
    "modelo": "GRAND AM",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "S320",
    "busquedas": "2"
  },
  {
    "marca": "KIA",
    "modelo": "TELLURIDE",
    "busquedas": "2"
  },
  {
    "marca": "PONTIAC",
    "modelo": "AZTEK",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "LUV",
    "busquedas": "2"
  },
  {
    "marca": "BMW",
    "modelo": "M3",
    "busquedas": "2"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "GOL",
    "busquedas": "2"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "I20",
    "busquedas": "2"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "DIAMANTE",
    "busquedas": "2"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "RANGE ROVER EVOQUE",
    "busquedas": "2"
  },
  {
    "marca": "MAZDA",
    "modelo": "E2200",
    "busquedas": "2"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "PASSAT CC",
    "busquedas": "2"
  },
  {
    "marca": "PEUGEOT",
    "modelo": "306",
    "busquedas": "2"
  },
  {
    "marca": "PEUGEOT",
    "modelo": "206",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SLK320",
    "busquedas": "2"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "TAOS",
    "busquedas": "2"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "TRANSPORTER",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CMP",
    "busquedas": "2"
  },
  {
    "marca": "DATSUN",
    "modelo": "PICKUP",
    "busquedas": "2"
  },
  {
    "marca": "NISSAN",
    "modelo": "TSURU",
    "busquedas": "2"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "AZERA",
    "busquedas": "2"
  },
  {
    "marca": "NISSAN",
    "modelo": "PULSAR NX",
    "busquedas": "2"
  },
  {
    "marca": "LEXUS",
    "modelo": "LS460",
    "busquedas": "2"
  },
  {
    "marca": "MERCURY",
    "modelo": "TOPAZ",
    "busquedas": "2"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 1500 CLASSIC",
    "busquedas": "2"
  },
  {
    "marca": "LINCOLN",
    "modelo": "MKS",
    "busquedas": "2"
  },
  {
    "marca": "NISSAN",
    "modelo": "210",
    "busquedas": "2"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 3500 HD",
    "busquedas": "2"
  },
  {
    "marca": "BMW",
    "modelo": "135I",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "G20",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GL350",
    "busquedas": "2"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "CRAFTER",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "S550",
    "busquedas": "1"
  },
  {
    "marca": "SATURN",
    "modelo": "SW2",
    "busquedas": "1"
  },
  {
    "marca": "JEEP",
    "modelo": "WAGONEER",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SPRINTER",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SONORA",
    "busquedas": "1"
  },
  {
    "marca": "FORD",
    "modelo": "THUNDERBIRD",
    "busquedas": "1"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "VIRTUS",
    "busquedas": "1"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "PRECIS",
    "busquedas": "1"
  },
  {
    "marca": "DODGE",
    "modelo": "B250",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "MATIZ",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "M5",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "C3500",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "325",
    "busquedas": "1"
  },
  {
    "marca": "AUDI",
    "modelo": "A7",
    "busquedas": "1"
  },
  {
    "marca": "INFINITI",
    "modelo": "G37",
    "busquedas": "1"
  },
  {
    "marca": "DODGE",
    "modelo": "RAMCHARGER",
    "busquedas": "1"
  },
  {
    "marca": "FORD",
    "modelo": "E-250 ECONOLINE",
    "busquedas": "1"
  },
  {
    "marca": "INFINITI",
    "modelo": "Q60",
    "busquedas": "1"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "GRAND VOYAGER",
    "busquedas": "1"
  },
  {
    "marca": "AUDI",
    "modelo": "A4 QUATTRO",
    "busquedas": "1"
  },
  {
    "marca": "GMC",
    "modelo": "SAVANA 1500",
    "busquedas": "1"
  },
  {
    "marca": "RAM",
    "modelo": "DAKOTA",
    "busquedas": "1"
  },
  {
    "marca": "RENAULT",
    "modelo": "KANGOO",
    "busquedas": "1"
  },
  {
    "marca": "TOYOTA",
    "modelo": "RAIZE",
    "busquedas": "1"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PRIUS C",
    "busquedas": "1"
  },
  {
    "marca": "JEEP",
    "modelo": "COMANCHE",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CRUZE LIMITED",
    "busquedas": "1"
  },
  {
    "marca": "TOYOTA",
    "modelo": "MR2 SPYDER",
    "busquedas": "1"
  },
  {
    "marca": "FIAT",
    "modelo": "124 SPIDER",
    "busquedas": "1"
  },
  {
    "marca": "NISSAN",
    "modelo": "MARCH",
    "busquedas": "1"
  },
  {
    "marca": "RENAULT",
    "modelo": "SCENIC",
    "busquedas": "1"
  },
  {
    "marca": "FORD",
    "modelo": "FIESTA IKON",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLS350D",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "CLK350",
    "busquedas": "1"
  },
  {
    "marca": "CHERY",
    "modelo": "TIGGO 4 PRO",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "EXPRESS PASAJEROS",
    "busquedas": "1"
  },
  {
    "marca": "VOLVO",
    "modelo": "V40 CROSS COUNTRY",
    "busquedas": "1"
  },
  {
    "marca": "VOLVO",
    "modelo": "V50",
    "busquedas": "1"
  },
  {
    "marca": "HONDA",
    "modelo": "CRX",
    "busquedas": "1"
  },
  {
    "marca": "ASTON MARTIN",
    "modelo": "DBS",
    "busquedas": "1"
  },
  {
    "marca": "VOLVO",
    "modelo": "V70",
    "busquedas": "1"
  },
  {
    "marca": "TOYOTA",
    "modelo": "COROLLA IM",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "430I",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLA250",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "DAMAS/LABO",
    "busquedas": "1"
  },
  {
    "marca": "FORD",
    "modelo": "MAVERICK",
    "busquedas": "1"
  },
  {
    "marca": "JAC",
    "modelo": "T8 PRO",
    "busquedas": "1"
  },
  {
    "marca": "JAGUAR",
    "modelo": "S-TYPE",
    "busquedas": "1"
  },
  {
    "marca": "DAEWOO",
    "modelo": "LEGANZA",
    "busquedas": "1"
  },
  {
    "marca": "TOYOTA",
    "modelo": "AGYA",
    "busquedas": "1"
  },
  {
    "marca": "JMC",
    "modelo": "JX",
    "busquedas": "1"
  },
  {
    "marca": "KIA",
    "modelo": "BORREGO",
    "busquedas": "1"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 3500",
    "busquedas": "1"
  },
  {
    "marca": "PEUGEOT",
    "modelo": "3008",
    "busquedas": "1"
  },
  {
    "marca": "LEXUS",
    "modelo": "RX450H",
    "busquedas": "1"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-70",
    "busquedas": "1"
  },
  {
    "marca": "MAZDA",
    "modelo": "MILLENIA",
    "busquedas": "1"
  },
  {
    "marca": "KIA",
    "modelo": "AMANTI",
    "busquedas": "1"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "NIVUS",
    "busquedas": "1"
  },
  {
    "marca": "MAZDA",
    "modelo": "MX-5 MIATA",
    "busquedas": "1"
  },
  {
    "marca": "MAXUS",
    "modelo": "D90",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SLK250",
    "busquedas": "1"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GENESIS",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "325IS",
    "busquedas": "1"
  },
  {
    "marca": "PLYMOUTH",
    "modelo": "BREEZE",
    "busquedas": "1"
  },
  {
    "marca": "ACURA",
    "modelo": "ZDX",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SLK350",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "C1500",
    "busquedas": "1"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "T-CROSS",
    "busquedas": "1"
  },
  {
    "marca": "LAMBORGHINI",
    "modelo": "MURCIELAGO",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "740IL",
    "busquedas": "1"
  }
];

export default preloadedVehiclesModels;
